import { render, staticRenderFns } from "./NuestrosProductos.vue?vue&type=template&id=5297aa0c&scoped=true&"
import script from "./NuestrosProductos.vue?vue&type=script&lang=js&"
export * from "./NuestrosProductos.vue?vue&type=script&lang=js&"
import style0 from "./NuestrosProductos.vue?vue&type=style&index=0&id=5297aa0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5297aa0c",
  null
  
)

export default component.exports